module.exports = __webpack_public_path__ + "img/APPC.e624e0e0.svg";